// extracted by mini-css-extract-plugin
export default {"zoomModal":"t2-z"};